import _ from 'underscore';
import $ from 'jquery';

import TastypieModel from 'models/tastypie';


export default TastypieModel.extend({
  params: mobile ? _.extend({
    username: window.localStorage.getItem('USERNAME'),
    api_key: window.localStorage.getItem('API_KEY'),
    auth: AUTH
  }, AUTH) : {},

  url: function () {
    var result = this.base_url();
    if (!_.isEmpty(this.params)) {
      result = result + ('?' + $.param(this.params));
    }
    return result;
  }
});



// WEBPACK FOOTER //
// ./static/js/models/tracker.js